import React, { Component } from 'react';
import { Modal, Select, Row, Button, message, Alert } from "antd";
import moment from "moment";
import FileSaver from "file-saver";
import { inject, observer } from "mobx-react";

const Option = Select.Option;

@inject('store')
@observer
class ExportPdf extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            date: moment().add(1, 'y').format('YYYY'),
            loading: false,
            dateData: [],
            hotel: {}
        }
    }

    async componentDidMount() {
        try {
            let date = Number(this.state.date || "0");
            let dateData = [];
            let len = date + 5 - 2010;

            for (let i = 0; i < len; i++) {
                dateData.push((2012 + i).toString())
            }

            let hotel = await this.props.store.menu.getHotelInfo();
            this.setState({ dateData, hotel });
        } catch (error) {
            console.log(error);
        }
    }

    onExportPdf = () => {
        this.setState({
            visible: true
        });
    }

    handleOk = () => {
        this.setState({ loading: true });
        let date = this.state.date;
        fetch(`/mkPdf_bp?year=${moment(date).format('YYYY')}`, { credentials: 'include' }).then(x => x.blob()).then(x => {
            let file = new Blob([x], { type: "application/pdf" });
            FileSaver.saveAs(file, `${this.state.hotel.name || ""}(${date}).pdf`);
            this.setState({ loading: false });
            message.info('导出成功！')
        }).catch(err => {
            this.setState({ loading: false });
            message.info('导出失败！')
            console.error(err);
        })

    }

    handleCancel = () => {
        this.setState({ visible: false });
    }
    render() {
        return (
            <div
                style={{ color: "#1890ff", cursor: "pointer", padding: "10px 20px", textAlign: "center" }}

            >
                <Button onClick={this.onExportPdf} type="primary" style={{ width: "100%" }}>一键导出</Button>
                <Modal
                    title="导出PDF"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loading} onClick={this.handleOk}>
                            {this.state.loading ? '导出中，请稍候......' : "导出"}
                        </Button>,
                    ]}
                >
                    <Row className="table-month">
                        <span style={{ marginRight: 20 }}>请选择年份：</span>
                        <Select
                            placeholder="请选择年份"
                            style={{ width: 120 }}
                            value={this.state.date}
                            onChange={(str) => {
                                this.setState({
                                    date: str,
                                });
                            }}
                        >
                            {this.state.dateData.map((x, i) => {
                                return (
                                    <Option value={x} key={x}>{x}年</Option>
                                )
                            })}
                        </Select>
                        <Alert
                            style={{ marginTop: 20 }}
                            message="警告"
                            description="由于导出内容过多，会导致页面卡顿，导出成功会自动生成pdf文件，在生成文件之前，请勿关闭浏览器和当前页面标签。。。"
                            type="error"

                        />
                    </Row>
                </Modal>
            </div>
        );
    }
}

export default ExportPdf;


// WEBPACK FOOTER //
// ./src/bp-views/app/ExportPdf.js